import { SaveAndCancelButton as ItkSaveAndCancelButton } from "@itk/mui-components";
import { SaveAndCancelButtonProps } from "./save-and-cancel-button-types";

export const SaveAndCancelButton = ({ stackDirection = "row-reverse", cancelButtonProps, ...props }: SaveAndCancelButtonProps) => (
  <ItkSaveAndCancelButton stackDirection={stackDirection} cancelButtonProps={{ variant: "outlined", ...cancelButtonProps }} {...props} />
);
